var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"formOrgNumber",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-text-field',{class:{
      'sub-errors-for-warning warning--text': _vm.validation.hasWarning
    },attrs:{"label":"Organisationsnummer","error-messages":_vm.errorMessages,"loading":_vm.validation.isLoading},model:{value:(_vm.orgNumber),callback:function ($$v) {_vm.orgNumber=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"orgNumber"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }